// Wave X-4 (2026-05-13) — 채팅 신고/모더레이션 admin 큐 UI
// 신고 목록 + 메시지 본문 미리보기 + 반려/숨김 액션

import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var REASON_LABELS = {
  spam: '스팸',
  abuse: '욕설/괴롭힘',
  fraud: '사기',
  inappropriate: '부적절',
  other: '기타',
};

function AdminChatReports({ showToast, th, td, badge, btnStyle }) {
  var [items, setItems] = useState([]);
  var [counts, setCounts] = useState({ pending: 0, dismissed: 0, actioned: 0 });
  var [status, setStatus] = useState('pending');
  var [loading, setLoading] = useState(false);

  function fetchList() {
    setLoading(true);
    authFetch(API + '/admin/chat-reports?status=' + encodeURIComponent(status) + '&limit=100')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) {
          setItems((d.data && d.data.items) || []);
          setCounts((d.data && d.data.counts) || { pending: 0, dismissed: 0, actioned: 0 });
        } else {
          showToast && showToast((d && d.error) || '조회 실패', 'error');
        }
      })
      .catch(function() { showToast && showToast('네트워크 오류', 'error'); })
      .finally(function() { setLoading(false); });
  }

  useEffect(function() { fetchList(); }, [status]);

  function review(id, action) {
    var body = { action: action };
    if (action === 'hide') {
      var reason = window.prompt('숨김 사유 (선택, 빈칸 가능)');
      if (reason === null) return;
      body.hide_reason = reason || '';
      if (!window.confirm('이 메시지를 숨기시겠습니까?\n양측 채팅에서 [관리자에 의해 숨겨진 메시지입니다]로 표시됩니다.')) return;
    } else {
      if (!window.confirm('이 신고를 반려하시겠습니까?')) return;
    }
    authFetch(API + '/admin/chat-reports/' + id + '/review', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) {
          showToast && showToast(action === 'hide' ? '메시지 숨김 완료' : '신고 반려 완료', 'success');
          fetchList();
        } else {
          showToast && showToast((d && d.error) || '처리 실패', 'error');
        }
      })
      .catch(function() { showToast && showToast('네트워크 오류', 'error'); });
  }

  function reporterName(r) {
    if (r.reporter_type === 'seller') return (r.reporter_user_name || '?') + ' (출품자)';
    return (r.reporter_buyer_name || '?') + ' (낙찰자)';
  }

  function senderName(r) {
    if (r.sender_user_id) return (r.sender_user_name || '?') + ' (출품자)';
    if (r.sender_buyer_id) return (r.sender_buyer_name || '?') + ' (낙찰자)';
    return '-';
  }

  function statusBadge(s) {
    if (s === 'actioned') return badge ? badge('inactive', '숨김처리') : '숨김처리';
    if (s === 'dismissed') return badge ? badge('none', '반려') : '반려';
    return badge ? badge('trial', '검토대기') : '검토대기';
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1B3A5C' }}>💬 채팅 신고</h3>
        <div style={{ display: 'flex', gap: 6 }}>
          <TabBtn active={status === 'pending'} onClick={function() { setStatus('pending'); }}>
            검토대기 ({counts.pending || 0})
          </TabBtn>
          <TabBtn active={status === 'actioned'} onClick={function() { setStatus('actioned'); }}>
            숨김처리 ({counts.actioned || 0})
          </TabBtn>
          <TabBtn active={status === 'dismissed'} onClick={function() { setStatus('dismissed'); }}>
            반려 ({counts.dismissed || 0})
          </TabBtn>
          <TabBtn active={status === 'all'} onClick={function() { setStatus('all'); }}>전체</TabBtn>
        </div>
        <button onClick={fetchList} style={Object.assign({}, btnStyle, { padding: '6px 14px', marginLeft: 'auto' })}>새로고침</button>
      </div>

      {loading ? (
        <div style={{ fontSize: 13, color: '#94a3b8' }}>불러오는 중...</div>
      ) : items.length === 0 ? (
        <div style={{ fontSize: 13, color: '#94a3b8', padding: 20, textAlign: 'center', background: '#f8fafc', borderRadius: 8 }}>
          {status === 'pending' ? '검토 대기 중인 신고가 없습니다 ✨' : '조건에 맞는 신고가 없습니다'}
        </div>
      ) : (
        <div>
          {items.map(function(r) {
            return (
              <div key={r.id} style={{ marginBottom: 12, padding: 14, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                  <div style={{ fontSize: 12, color: '#64748b' }}>
                    <span style={{ fontWeight: 700, color: '#1B3A5C' }}>#{r.id}</span>
                    {' · '}경매 #{r.auction_id} {r.auction_title || ''}
                    {' · '}신고일 {(r.created_at || '').slice(0, 16)}
                  </div>
                  <div>{statusBadge(r.status)}</div>
                </div>

                <div style={{ fontSize: 13, marginBottom: 6 }}>
                  <span style={{ color: '#64748b' }}>신고자:</span> <strong>{reporterName(r)}</strong>
                  {' · '}
                  <span style={{ display: 'inline-block', padding: '2px 8px', background: '#fef3c7', color: '#92400e', borderRadius: 10, fontSize: 11, fontWeight: 600 }}>
                    {REASON_LABELS[r.reason_code] || r.reason_code}
                  </span>
                  {r.reason_text && <span style={{ color: '#475569', marginLeft: 6 }}>· {r.reason_text}</span>}
                </div>

                <div style={{ padding: 10, background: '#f8fafc', borderRadius: 6, fontSize: 13, marginBottom: 8 }}>
                  <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 4 }}>
                    {senderName(r)} · {(r.message_created_at || '').slice(0, 16)}
                    {r.hidden_at && <span style={{ marginLeft: 8, color: '#dc2626', fontWeight: 700 }}>🚫 숨김처리됨</span>}
                  </div>
                  <div style={{ color: r.hidden_at ? '#94a3b8' : '#1f2937', textDecoration: r.hidden_at ? 'line-through' : 'none', whiteSpace: 'pre-wrap' }}>
                    {r.message_body || '[메시지 없음]'}
                  </div>
                </div>

                {r.status === 'pending' && (
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={function() { review(r.id, 'hide'); }} style={{ padding: '6px 14px', fontSize: 12, background: '#dc2626', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
                      🚫 메시지 숨김
                    </button>
                    <button onClick={function() { review(r.id, 'dismiss'); }} style={{ padding: '6px 14px', fontSize: 12, background: '#64748b', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
                      반려
                    </button>
                  </div>
                )}
                {r.status !== 'pending' && r.reviewed_at && (
                  <div style={{ fontSize: 11, color: '#94a3b8' }}>
                    처리일 {(r.reviewed_at || '').slice(0, 16)} · {r.action_taken === 'hide' ? '메시지 숨김' : '반려'}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function TabBtn({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '6px 12px',
        fontSize: 12,
        fontWeight: 600,
        background: active ? '#1B3A5C' : '#f1f5f9',
        color: active ? '#fff' : '#64748b',
        border: 'none',
        borderRadius: 6,
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  );
}

export default AdminChatReports;
